module.exports = __webpack_public_path__ + "static/img/award3_a.f740a8c.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/index/award3_a.png
// module id = nrrx
// module chunks = 7